
import { Component } from '@niknevis/vue-modules'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { Prop } from 'vue-property-decorator'

@Component
export default class CurrencyInput extends BaseInput {
  @Prop() maxInput!: number

  get __value() {
    const parsedValue = this.parseValueToNumber(this.valueSync)

    if (this.maxInput) {
      this.valueSync = parsedValue > this.maxInput ? this.maxInput : parsedValue
      if (Number.isNaN(this.valueSync)) this.valueSync = 0
    }

    return Number.isNaN(parsedValue) ? null : parsedValue.toLocaleString()
  }

  set __value(v) {
    if (v) {
      const parsedValue = this.parseValueToNumber(v)
      this.valueSync = Number.isNaN(parsedValue) ? null : parsedValue
    } else {
      this.valueSync = null
    }
  }

  get __attrs() {
    return Object.fromEntries(
      Object.entries(this.$attrs).filter(([key]) => key !== 'value')
    )
  }

  get __listeners() {
    return Object.fromEntries(
      Object.entries(this.$listeners).filter(([key]) => key !== 'input')
    )
  }

  parseValueToNumber(value) {
    return parseInt(value?.toString()?.replaceAll(',', ''), 10)
  }
}
